import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

export default function Navbar() {
  const [query, setQuery] = useState("")
  const navigate = useNavigate()

  function postData(e) {
    e.preventDefault()
    if (!query.trim()) return
    navigate(`/?q=${encodeURIComponent(query.trim())}`)
  }

  return (
    <div className="container-fluid bg-secondary">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-compact">
          <a className="navbar-brand text-light" href="/">
            InfoNation
          </a>

          <form onSubmit={postData} className="d-flex align-items-center ms-auto gap-2">
  <input
    className="form-control navbar-search"
    type="search"
    placeholder="Country..."
    onChange={(e) => setQuery(e.target.value)}
  />
  <button className="btn btn-light navbar-search-btn" type="submit">
    Search
  </button>
</form>

        </nav>
      </div>
    </div>
  )
}
